import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import api from '@/api';
import util from '@/libs/util.js';
export default {
  name: 'BasicSettingEdit',
  data: function data() {
    return {
      educations: [],
      marriages: [],
      minAges: [],
      maxAges: [],
      disabled: false,
      downUrl: process.env.VUE_APP_DOWNLOAD_URL,
      imageUrl: '',
      backImageUrl: '',
      shareImagesUrl: '',
      shareTimelineImageUrl: '',
      paymentQrCodeUrl: '',
      uploadUrl: process.env.VUE_APP_API,
      uploadHeaders: {
        Authorization: util.cookies.get('token')
      },
      fileList: [],
      title: '',
      form: {
        settingId: null,
        vipPhone: '',
        feeBkPhone: '',
        comBkPhone: '',
        giveCurrency: null,
        invitationGiveCurrency: null,
        loginTimeNum: null,
        indexDisNum: null,
        homepageResourceDynamicsNum: null,
        titleOne: '',
        describeOne: '',
        titleTwo: '',
        describeTwo: '',
        titleThree: '',
        describeThree: '',
        maxAge: null,
        minAge: null,
        marriage: '',
        education: '',
        cashBackAmount: null,
        logDescribe: '',
        logImg: '',
        cashBackDescribe: '',
        sensitiveWords: '',
        createTime: null,
        orderDescribe: null,
        angleOfAffinitySaveNum: null,
        defaultMemberBakImg: null,
        giveCard: null,
        authNum: null,
        firstFlushDiscount: null,
        angleOfAffinityDisplayNum: null,
        dynamicLimitNum: null,
        freeExperienceNum: null,
        vaCertificationPrice: null,
        vaCertificationNum: null,
        headImgStat: null,
        goodFaithDatingCornerPushNum: null,
        goodFaithUploadImg: null,
        goodFaithAddv: null,
        goodFaithAuth: null,
        goodFaithShare: null,
        goodFaithInvitation: null,
        goodFaithPushDynamic: null,
        defaultGoodFaithNum: null,
        authPrice: null,
        shareImages: null,
        shareTitle: null,
        shareUrl: null,
        shareTimelineImage: null,
        shareTimelineTitle: null,
        giveWomenMemberNum: null,
        proxySettlementRatio: null,
        matchmakerSettlementRatio: null,
        recommendPlatformMatchmakerSettlementRatio: null,
        recommendProxyMatchmakerSettlementRatio: null,
        recommendProxySettlementRatio: null,
        openMatchmakerResourcesYearsLineNum: null,
        openMatchmakerResourcesYearsNum: null,
        femaleFreeMembershipMonths: null,
        maleFreeMembershipMonths: null,
        withdrawalContractNumber: null,
        withdrawalDeductionRatio: null,
        memberIndexViewNum: null,
        memberResourcesViewNum: null,
        memberDynamicsViewNum: null,
        showLoginBtnFlag: 0,
        masterAgentRewardPercent: null,
        resourceSwitchBandSts: 0,
        visitorBandViewsNum: null,
        superAgentSettlementRatio: null,
        memberRechargeHandPrice: null,
        memberRechargeHandDay: null,
        memberRechargeHandAgencyRatio: null,
        memberRechargeHandGeneralAgencyRatio: null,
        memberRechargeGeneralAgencyRatio: null,
        paymentQrCode: null,
        contactTaViewNum: null,
        smsDailyLimit: null,
        matchmakerIdentityAuthAmount: null,
        handRechargeChannelRatio: null,
        memberRechargeChannelRatio: null,
        matchmakerRechargeChannelRatio: null
      },
      rules: {
        memberIndexViewNum: [{
          required: true,
          message: '会员首页显示数量限制不能为空',
          trigger: 'blur'
        }],
        memberResourcesViewNum: [{
          required: true,
          message: '会员资源库显示数量限制不能为空',
          trigger: 'blur'
        }],
        memberDynamicsViewNum: [{
          required: true,
          message: '会员动态显示数量限制不能为空',
          trigger: 'blur'
        }],
        withdrawalDeductionRatio: [{
          required: true,
          message: '提现扣税比例不能未空',
          trigger: 'blur'
        }],
        withdrawalContractNumber: [{
          required: true,
          message: '结算提现合同编号（第三方）不能未空',
          trigger: 'blur'
        }],
        femaleFreeMembershipMonths: [{
          required: true,
          message: '女性免费会员月数不能未空',
          trigger: 'blur'
        }],
        maleFreeMembershipMonths: [{
          required: true,
          message: '男性免费会员月数不能未空',
          trigger: 'blur'
        }],
        homepageResourceDynamicsNum: [{
          required: true,
          message: '首页资源动态限制数量不能未空',
          trigger: 'blur'
        }],
        vaCertificationPrice: [{
          required: true,
          message: '请输入V认证充值金额',
          trigger: 'blur'
        }],
        vaCertificationNum: [{
          required: true,
          message: '请输入V认证充值月数',
          trigger: 'blur'
        }],
        settingId: [{
          required: true,
          message: '请输入主键',
          trigger: 'blur'
        }],
        vipPhone: [{
          required: true,
          message: '请输入加V手机号码',
          trigger: 'blur'
        }],
        feeBkPhone: [{
          required: true,
          message: '请输入反馈手机号',
          trigger: 'blur'
        }],
        comBkPhone: [{
          required: true,
          message: '请输入投诉反馈手机号',
          trigger: 'blur'
        }],
        giveCurrency: [{
          required: true,
          message: '请输入默认赠送币数',
          trigger: 'blur'
        }],
        invitationGiveCurrency: [{
          required: true,
          message: '请输入默认邀请赠送币数',
          trigger: 'blur'
        }],
        loginTimeNum: [{
          required: true,
          message: '请输入会员未登陆天数限制',
          trigger: 'blur'
        }],
        indexDisNum: [{
          required: true,
          message: '请输入首页显示数据默认条数',
          trigger: 'blur'
        }],
        titleOne: [{
          required: true,
          message: '请输入标题1',
          trigger: 'blur'
        }],
        describeOne: [{
          required: true,
          message: '请输入描述1',
          trigger: 'blur'
        }],
        titleTwo: [{
          required: true,
          message: '请输入标题2',
          trigger: 'blur'
        }],
        describeTwo: [{
          required: true,
          message: '请输入描述2',
          trigger: 'blur'
        }],
        titleThree: [{
          required: true,
          message: '请输入标题3',
          trigger: 'blur'
        }],
        describeThree: [{
          required: true,
          message: '请输入描述3',
          trigger: 'blur'
        }],
        maxAge: [{
          required: true,
          message: '请输入最大年龄',
          trigger: 'blur'
        }],
        minAge: [{
          required: true,
          message: '请输入最小年龄',
          trigger: 'blur'
        }],
        marriage: [{
          required: true,
          message: '请输入婚姻限制',
          trigger: 'blur'
        }],
        education: [{
          required: true,
          message: '请输入学历限制',
          trigger: 'blur'
        }],
        cashBackAmount: [{
          required: true,
          message: '请输入返现金额',
          trigger: 'blur'
        }],
        logDescribe: [{
          required: true,
          message: '请输入小程序log文件',
          trigger: 'blur'
        }],
        logImg: [{
          required: true,
          message: '请输入小程序图标',
          trigger: 'blur'
        }],
        cashBackDescribe: [{
          required: true,
          message: '请输入返现描述',
          trigger: 'blur'
        }],
        sensitiveWords: [{
          required: true,
          message: '请输入敏感词配置',
          trigger: 'blur'
        }],
        createTime: [{
          required: true,
          message: '请输入创建时间',
          trigger: 'blur'
        }],
        defaultMemberBakImg: [{
          required: true,
          message: '请上传会员默认背景图片',
          trigger: 'blur'
        }],
        angleOfAffinitySaveNum: [{
          required: true,
          message: '请添写相亲角推送记录保存天数',
          trigger: 'blur'
        }],
        orderDescribe: [{
          required: true,
          message: '请输入订单描述',
          trigger: 'blur'
        }],
        giveCard: [{
          required: false,
          message: '请输入赠卡',
          trigger: 'blur'
        }],
        authNum: [{
          required: true,
          message: '请输入实名认证赠币',
          trigger: 'blur'
        }],
        firstFlushDiscount: [{
          required: false,
          message: '请输入会员首冲优惠金额',
          trigger: 'blur'
        }],
        angleOfAffinityDisplayNum: [{
          required: true,
          message: '请输入访客浏览相亲角限制条数',
          trigger: 'blur'
        }],
        dynamicLimitNum: [{
          required: true,
          message: '请输入访客浏览动态限制条数',
          trigger: 'blur'
        }],
        freeExperienceNum: [{
          required: true,
          message: '请输入会员中心免费领取体验',
          trigger: 'blur'
        }],
        headImgStat: [{
          required: true,
          message: '请选择头像限制',
          trigger: 'blur'
        }],
        defaultGoodFaithNum: [{
          required: true,
          message: '注册默认诚意值数不能为空',
          trigger: 'blur'
        }],
        goodFaithDatingCornerPushNum: [{
          required: true,
          message: '相亲角推送诚意值不能为空',
          trigger: 'blur'
        }],
        goodFaithUploadImg: [{
          required: true,
          message: '上传相册诚意值不能为空',
          trigger: 'blur'
        }],
        goodFaithAddv: [{
          required: true,
          message: 'V认证诚意值不能为空',
          trigger: 'blur'
        }],
        goodFaithAuth: [{
          required: true,
          message: '实名认证诚意值不能为空',
          trigger: 'blur'
        }],
        goodFaithPushDynamic: [{
          required: true,
          message: '发布动态诚意值不能为空',
          trigger: 'blur'
        }],
        goodFaithShare: [{
          required: true,
          message: '分享诚意值不能为空',
          trigger: 'blur'
        }],
        goodFaithInvitation: [{
          required: true,
          message: '邀请好友诚意值不能为空',
          trigger: 'blur'
        }],
        authPrice: [{
          required: true,
          message: '身份认证价格不能为空',
          trigger: 'blur'
        }],
        shareImages: [{
          required: true,
          message: '分享展示图片不能为空',
          trigger: 'blur'
        }],
        paymentQrCode: [{
          required: true,
          message: '付款码图片不能为空',
          trigger: 'blur'
        }],
        contactTaViewNum: [{
          required: true,
          message: '联系TA浏览次数限制不能为空',
          trigger: 'blur'
        }],
        smsDailyLimit: [{
          required: false,
          message: '短信每日发送上限不能为空',
          trigger: 'blur'
        }],
        matchmakerIdentityAuthAmount: [{
          required: true,
          message: '红娘身份授权金额不能为空',
          trigger: 'blur'
        }],
        // 屏蔽以下 3 个渠道结算比例规则：暂时不再实施结算
        // handRechargeChannelRatio: [
        //   { required: true, message: '牵手充值渠道结算比例不能为空', trigger: 'blur' }
        // ],
        // memberRechargeChannelRatio: [
        //   { required: true, message: '会员充值渠道结算比例不能为空', trigger: 'blur' }
        // ],
        // matchmakerRechargeChannelRatio: [
        //   { required: true, message: '红娘充值渠道结算比例不能为空', trigger: 'blur' }
        // ],
        shareTitle: [{
          required: true,
          message: '分享显示描述不能为空',
          trigger: 'blur'
        }],
        shareTimelineImage: [{
          required: true,
          message: '分享朋友圈图片不能为空',
          trigger: 'blur'
        }],
        shareTimelineTitle: [{
          required: true,
          message: '分享朋友圈标题不能为空',
          trigger: 'blur'
        }],
        giveWomenMemberNum: [{
          required: true,
          message: '女性用户免费年数不能为空',
          trigger: 'blur'
        }],
        proxySettlementRatio: [{
          required: true,
          message: '代理结算比例不能为空',
          trigger: 'blur'
        }],
        matchmakerSettlementRatio: [{
          required: true,
          message: '红娘代理比例不能为空',
          trigger: 'blur'
        }],
        recommendPlatformMatchmakerSettlementRatio: [{
          required: true,
          message: '推荐红娘平台奖励比例不能为空',
          trigger: 'blur'
        }],
        recommendProxyMatchmakerSettlementRatio: [{
          required: true,
          message: '推荐红娘代理奖励比例不能为空',
          trigger: 'blur'
        }],
        recommendProxySettlementRatio: [{
          required: true,
          message: '推荐代理代理奖励比例不能为空',
          trigger: 'blur'
        }],
        openMatchmakerResourcesYearsNum: [{
          required: true,
          message: '红娘推送资源库显示年数不能为空',
          trigger: 'blur'
        }],
        openMatchmakerResourcesYearsLineNum: [{
          required: true,
          message: '访客浏览资源库限制条数不能为空',
          trigger: 'blur'
        }],
        masterAgentRewardPercent: [{
          required: true,
          message: '推荐代理总代奖励比例不能为空',
          trigger: 'blur'
        }],
        resourceSwitchBandSts: [{
          required: true,
          message: '代征/牵手开关不能为空',
          trigger: 'blur'
        }],
        visitorBandViewsNum: [{
          required: true,
          message: '访客浏览牵手限制条数不能为空',
          trigger: 'blur'
        }],
        superAgentSettlementRatio: [{
          required: true,
          message: '代理结算比例不能为空',
          trigger: 'blur'
        }],
        memberRechargeHandPrice: [{
          required: true,
          message: '牵手充值金额不能为空',
          trigger: 'blur'
        }],
        memberRechargeHandDay: [{
          required: true,
          message: '牵手充值月数不能为空',
          trigger: 'blur'
        }],
        memberRechargeHandAgencyRatio: [{
          required: true,
          message: '牵手充值代理结算比例不能为空',
          trigger: 'blur'
        }],
        memberRechargeHandGeneralAgencyRatio: [{
          required: true,
          message: '牵手充值总代结算比例不能为空',
          trigger: 'blur'
        }],
        memberRechargeGeneralAgencyRatio: [{
          required: true,
          message: '会员充值总代结算比例不能为空',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    getEducationsEnumList: function getEducationsEnumList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: 'mbmber_education_ranche_select'
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this.educations = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getMarriagesEnumList: function getMarriagesEnumList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                name: 'mbmber_marriage_select'
              };
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context2.v;
              _this2.marriages = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getMemberAgeEnumList: function getMemberAgeEnumList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par, res, data, index, item, values, min, max, datas, i;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                name: 'member_age_select'
              };
              _context3.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context3.v;
              data = res.body;
              for (index in data) {
                item = data[index];
                values = item.values.split('-');
                min = values[0];
                max = values[1];
                datas = [];
                for (i = parseInt(min); i <= parseInt(max); i++) {
                  datas.push(i);
                }
                if (item.keys === 'max') {
                  _this3.maxAges = datas;
                } else {
                  _this3.minAges = datas;
                }
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.imageUrl = this.downUrl + '/' + res.body.url;
      this.form.logImg = res.body.url;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件不能超过 10MB!');
      }
      return isLt2M;
    },
    shareHandleAvatarSuccess: function shareHandleAvatarSuccess(res, file) {
      this.shareImagesUrl = this.downUrl + '/' + res.body.url;
      this.form.shareImages = res.body.url;
    },
    shareBeforeAvatarUpload: function shareBeforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件不能超过 10MB!');
      }
      return isLt2M;
    },
    shareTimelineHandleAvatarSuccess: function shareTimelineHandleAvatarSuccess(res, file) {
      this.shareTimelineImageUrl = this.downUrl + '/' + res.body.url;
      this.form.shareTimelineImage = res.body.url;
    },
    shareTimelineBeforeAvatarUpload: function shareTimelineBeforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件不能超过 10MB!');
      }
      return isLt2M;
    },
    backHandleAvatarSuccess: function backHandleAvatarSuccess(res, file) {
      this.backImageUrl = this.downUrl + '/' + res.body.url;
      this.form.defaultMemberBakImg = res.body.url;
    },
    backBeforeAvatarUpload: function backBeforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件不能超过 10MB!');
      }
      return isLt2M;
    },
    paymentQrCodeHandleAvatarSuccess: function paymentQrCodeHandleAvatarSuccess(res, file) {
      this.paymentQrCodeUrl = this.downUrl + '/' + res.body.url;
      this.form.paymentQrCode = res.body.url;
    },
    paymentQrCodeBeforeAvatarUpload: function paymentQrCodeBeforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件不能超过 10MB!');
      }
      return isLt2M;
    },
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              par = {
                name: name
              };
              _context4.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context4.v;
              _this4.enumList = res.body;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.settingId = null;
      this.form.vipPhone = null;
      this.form.feeBkPhone = null;
      this.form.comBkPhone = null;
      this.form.giveCurrency = null;
      this.form.invitationGiveCurrency = null;
      this.form.loginTimeNum = null;
      this.form.indexDisNum = null;
      this.form.titleOne = null;
      this.form.describeOne = null;
      this.form.titleTwo = null;
      this.form.describeTwo = null;
      this.form.titleThree = null;
      this.form.describeThree = null;
      this.form.maxAge = null;
      this.form.minAge = null;
      this.form.marriage = null;
      this.form.education = null;
      this.form.cashBackAmount = null;
      this.form.logDescribe = null;
      this.form.logImg = null;
      this.form.cashBackDescribe = null;
      this.form.sensitiveWords = null;
      this.form.createTime = null;
      this.form.orderDescribe = null;
      this.form.defaultMemberBakImg = null;
      this.form.angleOfAffinitySaveNum = null;
      this.form.giveCard = null;
      this.form.authNum = null;
      this.form.firstFlushDiscount = null;
      this.form.angleOfAffinityDisplayNum = null;
      this.form.dynamicLimitNum = null;
      this.form.freeExperienceNum = null;
      this.form.vaCertificationPrice = null;
      this.form.vaCertificationNum = null;
      this.form.headImgStat = 0;
      this.form.defaultGoodFaithNum = null;
      this.form.goodFaithDatingCornerPushNum = null;
      this.form.goodFaithUploadImg = null;
      this.form.goodFaithAddv = null;
      this.form.goodFaithAuth = null;
      this.form.goodFaithPushDynamic = null;
      this.form.goodFaithInvitation = null;
      this.form.goodFaithShare = null;
      this.form.authPrice = null;
      this.form.giveWomenMemberNum = null;
      this.form.proxySettlementRatio = null;
      this.form.matchmakerSettlementRatio = null;
      this.form.recommendPlatformMatchmakerSettlementRatio = null;
      this.form.recommendProxyMatchmakerSettlementRatio = null;
      this.form.recommendProxySettlementRatio = null;
      this.form.homepageResourceDynamicsNum = null;
      this.form.femaleFreeMembershipMonths = null;
      this.form.maleFreeMembershipMonths = null;
      this.form.withdrawalContractNumber = null;
      this.form.withdrawalDeductionRatio = null;
      this.form.memberIndexViewNum = null;
      this.form.memberResourcesViewNum = null;
      this.form.memberDynamicsViewNum = null;
      this.form.showLoginBtnFlag = null;
      this.form.masterAgentRewardPercent = null;
      this.form.resourceSwitchBandSts = null;
      this.form.visitorBandViewsNum = null;
      this.form.superAgentSettlementRatio = null;
      this.form.memberRechargeHandDay = null;
      this.form.memberRechargeHandPrice = null;
      this.form.memberRechargeHandAgencyRatio = null;
      this.form.memberRechargeHandDeductionRatio = null;
      this.form.paymentQrCode = null;
      this.form.contactTaViewNum = null;
      this.form.smsDailyLimit = null;
      this.form.handRechargeChannelRatio = null;
      this.form.memberRechargeChannelRatio = null;
      this.form.matchmakerRechargeChannelRatio = null;
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.settingId = data.settingId + '';
      this.form.vipPhone = data.vipPhone;
      this.form.feeBkPhone = data.feeBkPhone;
      this.form.comBkPhone = data.comBkPhone;
      this.form.giveCurrency = data.giveCurrency + '';
      this.form.invitationGiveCurrency = data.invitationGiveCurrency + '';
      this.form.loginTimeNum = data.loginTimeNum + '';
      this.form.indexDisNum = data.indexDisNum + '';
      this.form.titleOne = data.titleOne;
      this.form.describeOne = data.describeOne;
      this.form.titleTwo = data.titleTwo;
      this.form.describeTwo = data.describeTwo;
      this.form.titleThree = data.titleThree;
      this.form.describeThree = data.describeThree;
      this.form.maxAge = data.maxAge + '';
      this.form.minAge = data.minAge + '';
      this.form.marriage = data.marriage;
      this.form.education = data.education;
      this.form.cashBackAmount = data.cashBackAmount + '';
      this.form.logDescribe = data.logDescribe;
      this.form.logImg = data.logImg;
      this.imageUrl = this.downUrl + '/' + data.logImg;
      this.backImageUrl = this.downUrl + '/' + data.defaultMemberBakImg;
      this.shareImagesUrl = this.downUrl + '/' + data.shareImages;
      this.form.shareImages = data.shareImages;
      this.form.shareTitle = data.shareTitle;
      this.form.shareTimelineImage = data.shareTimelineImage;
      this.form.shareTimelineTitle = data.shareTimelineTitle;
      this.shareTimelineImageUrl = data.shareTimelineImage ? this.downUrl + '/' + data.shareTimelineImage : '';
      this.form.cashBackDescribe = data.cashBackDescribe;
      this.form.sensitiveWords = data.sensitiveWords;
      this.form.createTime = data.createTime + '';
      this.form.orderDescribe = data.orderDescribe;
      this.form.defaultMemberBakImg = data.defaultMemberBakImg;
      this.form.angleOfAffinitySaveNum = data.angleOfAffinitySaveNum;
      this.form.giveCard = data.giveCard;
      this.form.authNum = data.authNum;
      this.form.firstFlushDiscount = data.firstFlushDiscount;
      this.form.angleOfAffinityDisplayNum = data.angleOfAffinityDisplayNum;
      this.form.dynamicLimitNum = data.dynamicLimitNum;
      this.form.freeExperienceNum = data.freeExperienceNum;
      this.form.vaCertificationNum = data.vaCertificationNum;
      this.form.vaCertificationPrice = data.vaCertificationPrice;
      this.form.headImgStat = data.headImgStat;
      this.form.defaultGoodFaithNum = data.defaultGoodFaithNum;
      this.form.goodFaithDatingCornerPushNum = data.goodFaithDatingCornerPushNum;
      this.form.goodFaithUploadImg = data.goodFaithUploadImg;
      this.form.goodFaithAddv = data.goodFaithAddv;
      this.form.goodFaithAuth = data.goodFaithAuth;
      this.form.goodFaithPushDynamic = data.goodFaithPushDynamic;
      this.form.goodFaithInvitation = data.goodFaithInvitation;
      this.form.goodFaithShare = data.goodFaithShare;
      this.form.authPrice = data.authPrice;
      this.form.giveWomenMemberNum = data.giveWomenMemberNum;
      this.form.proxySettlementRatio = data.proxySettlementRatio;
      this.form.matchmakerSettlementRatio = data.matchmakerSettlementRatio;
      this.form.recommendPlatformMatchmakerSettlementRatio = data.recommendPlatformMatchmakerSettlementRatio;
      this.form.recommendProxyMatchmakerSettlementRatio = data.recommendProxyMatchmakerSettlementRatio;
      this.form.recommendProxySettlementRatio = data.recommendProxySettlementRatio;
      this.form.openMatchmakerResourcesYearsLineNum = data.openMatchmakerResourcesYearsLineNum;
      this.form.openMatchmakerResourcesYearsNum = data.openMatchmakerResourcesYearsNum;
      this.form.homepageResourceDynamicsNum = data.homepageResourceDynamicsNum;
      this.form.maleFreeMembershipMonths = data.maleFreeMembershipMonths;
      this.form.femaleFreeMembershipMonths = data.femaleFreeMembershipMonths;
      this.form.withdrawalContractNumber = data.withdrawalContractNumber;
      this.form.withdrawalDeductionRatio = data.withdrawalDeductionRatio;
      this.form.memberIndexViewNum = data.memberIndexViewNum;
      this.form.memberResourcesViewNum = data.memberResourcesViewNum;
      this.form.memberDynamicsViewNum = data.memberDynamicsViewNum;
      this.form.showLoginBtnFlag = data.showLoginBtnFlag;
      this.form.masterAgentRewardPercent = data.masterAgentRewardPercent;
      this.form.resourceSwitchBandSts = data.resourceSwitchBandSts;
      this.form.visitorBandViewsNum = data.visitorBandViewsNum;
      this.form.superAgentSettlementRatio = data.superAgentSettlementRatio;
      this.form.memberRechargeHandDay = data.memberRechargeHandDay;
      this.form.memberRechargeHandPrice = data.memberRechargeHandPrice;
      this.form.memberRechargeHandAgencyRatio = data.memberRechargeHandAgencyRatio;
      this.form.memberRechargeHandGeneralAgencyRatio = data.memberRechargeHandGeneralAgencyRatio;
      this.form.memberRechargeGeneralAgencyRatio = data.memberRechargeGeneralAgencyRatio;
      this.paymentQrCodeUrl = this.downUrl + '/' + data.paymentQrCode;
      this.form.paymentQrCode = data.paymentQrCode;
      this.form.contactTaViewNum = data.contactTaViewNum;
      this.form.smsDailyLimit = data.smsDailyLimit;
      this.form.matchmakerIdentityAuthAmount = data.matchmakerIdentityAuthAmount;
      this.form.handRechargeChannelRatio = data.handRechargeChannelRatio;
      this.form.memberRechargeChannelRatio = data.memberRechargeChannelRatio;
      this.form.matchmakerRechargeChannelRatio = data.matchmakerRechargeChannelRatio;
    },
    updateApi: function updateApi() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return api.UPDATE_BASICSETTING(_this5.form);
            case 1:
              _this5.$emit('initTableData');
              _this5.$message.success('操作成功');
              _this5.handleClose();
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    saveApi: function saveApi() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return api.SAVE_BASICSETTING(_this6.form);
            case 1:
              _this6.$emit('initTableData');
              _this6.$message.success('操作成功');
              _this6.handleClose();
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    initNetData: function initNetData() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var par, res, data;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              par = {
                pageNo: 1,
                pageSize: 20
              };
              _context7.n = 1;
              return api.GET_BASICSETTING_PAGE_LIST(par);
            case 1:
              res = _context7.v;
              data = res.body.datas[0];
              _this7.setData(data);
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    save: function save() {
      var _this8 = this;
      // 以下 5 个账号角色暂时不再实施结算：保存前强制将比例置为 0
      this.form.memberRechargeHandGeneralAgencyRatio = 0;
      this.form.handRechargeChannelRatio = 0;
      this.form.memberRechargeChannelRatio = 0;
      this.form.matchmakerRechargeChannelRatio = 0;
      this.form.memberRechargeGeneralAgencyRatio = 0;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this8.form.settingId != null) {
            _this8.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this8.updateApi();
            }).catch(function () {
              _this8.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this8.saveApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  },
  created: function created() {
    this.getEducationsEnumList();
    this.getMarriagesEnumList();
    this.getMemberAgeEnumList();
    this.initNetData();
  }
};